module.exports = __webpack_public_path__ + "img/405.cd4931b0.png";